export default __webpack_public_path__ + "static/Video-462a668b0d4d29f3220a3f79ab246631.jpg";